
import { Route, Routes } from "react-router-dom";
import { useContext, useEffect, useState } from "react";

import { RoleContext } from "../utils/contexts/RoleContext";


export default function Middlepart() {
    const currentUser = useContext(RoleContext);
    return (
        <></>
        // <Routes>
        //     <Route />
        // </Routes>
    )
}